import { Bx, Typo } from '@curry-group/mui-curcuma';
import { Grid } from '@material-ui/core';
import React from 'react';
import { allowedMimeTypes } from '../../../helper/validator';
import { FormDropZone } from '../controls/dropzone';
import { FormInput } from '../controls/input';
import { FormRTE } from '../controls/rte';
interface IFormProject {
  formData: any;
  headline?: string;
  subtitle?: string;
  onChange: (value: any) => void;
}

export const FormProject: React.FC<IFormProject> = ({ formData, headline, subtitle, onChange }) => {
  return (
    <React.Fragment>
      {headline && (
        <Bx mb={1}>
          <Typo variant="h1" component="h1">
            {headline}
          </Typo>
        </Bx>
      )}
      {subtitle && <Typo variant="subtitle1">{subtitle}</Typo>}
      <Bx my={headline || subtitle ? 8 : 0}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={12}>
            <FormInput
              value={formData?.itemData?.title}
              label={'Titel des Projekts'}
              placeholder={'Titel eingeben'}
              minLength={5}
              maxLength={120}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, title: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormRTE
              value={formData?.itemData?.description}
              label={'Kurzbeschreibung'}
              placeholder={'Erzählen Sie uns mehr von diesem Projekt...'}
              mandatory={true}
              minLength={100}
              maxLength={2500}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, description: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormDropZone
              value={formData?.avatar ? formData.avatar : []}
              label={'Projektlogo'}
              placeholder={'Bild hochladen oder drag&drop'}
              mandatory={false}
              accept={'image/*'}
              onChange={val => {
                onChange({ ...formData, avatar: val });
              }}
              multiple={false}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormDropZone
              value={formData?.keyvisual ? formData.keyvisual : []}
              label={'Hintergrundbild'}
              placeholder={'Bild hochladen oder drag&drop'}
              mandatory={false}
              accept={'image/*'}
              onChange={val => {
                onChange({ ...formData, keyvisual: val });
              }}
              multiple={false}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormDropZone
              value={formData?.attachments ? formData.attachments : []}
              label={'Anhänge'}
              placeholder={'Hochladen oder Datei(en) hier ablegen'}
              mandatory={false}
              accept={allowedMimeTypes}
              onChange={val => {
                onChange({ ...formData, attachments: val });
              }}
              multiple
            />
          </Grid>
        </Grid>
      </Bx>
    </React.Fragment>
  );
};
